<template src='./header.html'></template>
<script>
import Vue from 'vue'
import { logout, authorizedUserName, hasAdminClaim } from '@/router/auth.js'
import { getUser } from '@/utils/cookie.js'
import { EventBus } from '@/router/bus'

export default {
  // name: 'header',
  data () {
    return {
      environment: process.env.NODE_ENV,
      login: '',
      username: '',
      registrationAllowed: Vue.$config.registration_allowed,
      logout: logout
    }
  },
  methods: {
    profile () {
      this.$router.push({ name: 'userProfile' })
    },
    sideIconClickHandle () {
      this.$emit('toolbarSideIconClick')
    },
    isAdmin () {
      return hasAdminClaim()
    }
  },
  created () {
    this.login = getUser()
    this.username = authorizedUserName()
    EventBus.$on('logged-in', () => {
      this.login = getUser()
      this.username = authorizedUserName()
    })
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
@import "~@/assets/scss/variables.scss";

.heavier-text {
  font-weight: 600;
}

a {
  color: white;
  text-decoration: none;
}

.toolbar-button {
  text-transform: none !important;
}

.toolbar-button-item {
  text-transform: none !important;
  pointer-events: none;
}

.selected-toolbar-button {
   background-color: #429a86;
}
</style>
